// extracted by mini-css-extract-plugin
export default {"trackingContainer":"return_trackingContainer__7fi6b"};